import type { SVGProps } from "react";
import * as React from "react";

const Svg2Layers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12 4.5.447-.894a1 1 0 0 0-.894 0zm-10 5-.447-.894a1 1 0 0 0 0 1.788zm10 5-.447.894a1 1 0 0 0 .894 0zm10-5 .447.894a1 1 0 0 0 0-1.788zM2.447 13.606a1 1 0 1 0-.894 1.788zM12 19.5l-.447.894a1 1 0 0 0 .894 0zm10.447-4.106a1 1 0 1 0-.894-1.788zM11.553 3.606l-10 5 .894 1.788 10-5zm-10 6.788 10 5 .894-1.788-10-5zm10.894 5 10-5-.894-1.788-10 5zm10-6.788-10-5-.894 1.788 10 5zM1.553 15.394l10 5 .894-1.788-10-5zm10.894 5 10-5-.894-1.788-10 5z"
    />
  </svg>
);
export default Svg2Layers;
